import clsx from 'clsx';
import React, { useRef } from 'react';
import { Typography, Icon } from '@hevoio/hevo-ui-toolkit';
import styles from './AppbarSupportCTA.module.scss';
import OverlayBadgeLabel from '../../../../badge/components/label/OverlayBadge';
import useAnalyticsTracker from '../../../../analytics/hooks/useAnalyticsTracker';

interface AppbarSupportCTAProps {
  iconName?: string;
  label: string;
  trackingEvent: string;
  supportPersonImageURL?: string;
  showOnCallSupportIndicator: Boolean;
  badgeContent: string;
  onClick?: Function;
}
export function AppbarSupportCTA({
  iconName,
  label,
  trackingEvent,
  supportPersonImageURL,
  showOnCallSupportIndicator,
  badgeContent,
  onClick
}: AppbarSupportCTAProps) {
  const ref = useRef<any>();

  const analyticsTracker = useAnalyticsTracker();

  const handleClick = () => {
    analyticsTracker.eventTrack({ action: trackingEvent });
    if (typeof onClick !== 'undefined') {
      onClick();
    }
  };

  return (
    <div onClick={handleClick} ref={ref} className={styles.appbarCtaContainer}>
      <OverlayBadgeLabel
        content={badgeContent}
        color='error'
        direction={{ vertical: 'top', horizontal: 'right' }}
      >
        <div
          className={clsx(
            'mt-1 position-relative',
            styles.appbarCtaIconContainer,
            showOnCallSupportIndicator && styles.supportStatusDot
          )}
        >
          <div
            className={`${styles.appbarCtaIconWrapper} center-flex-row justify-center`}
          >
            {iconName && <Icon name={iconName} className={styles.appbarCtaIcon} />}

            {supportPersonImageURL && <img src={supportPersonImageURL} alt='' />}
          </div>
        </div>
      </OverlayBadgeLabel>

      <Typography level='label-x-small' color='light' className='mt-2 text-center'>{label}</Typography>
    </div>
  );
}
